<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div
    class="d-flex align-center"
  >
    <template v-if="size==='normal'">
      <v-avatar
        class="mr-2"
        size="24"
        tile
      >
        <v-img :src="require('@/assets/new/logo/logo.png')" />
      </v-avatar>
      <div
        class="text-body-2"
      >
        Aaden
        <span class="font-weight-black mr-1">POS</span>
        <template v-if="withVersion">
          v{{ version }}
        </template>
      </div>
    </template>
    <template v-else>
      <v-avatar
        class="mr-2"
        size="36"
        tile
      >
        <v-img :src="require('@/assets/new/logo/logo.png')" />
      </v-avatar>
      <div
        class="text-h3 text-no-wrap"
      >
        Aaden
        <span class="font-weight-black mr-1">POS</span>
      </div>
    </template>
  </div>
</template>

<script>
const { version } = require('../../../../package.json')
export default {
  name: 'LogoDisplay',
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    withVersion: {}
  },
  data: function () {
    return {
      version
    }
  }
}
</script>

<style scoped>

</style>
